<div class="collapsible"
[class.over]="overlay" [class.open]="open"

 [@openState]="openState">
 
    <ng-content></ng-content>

</div>
<div class="overlay-blue fadein-quick" *ngIf="overlay && openState === 'open'">
</div>
    